import {stringify} from 'qs';
import {v4 as uuidv4} from 'uuid';
import {SearchRankItemVo} from '../../common/shared/api/nicolas/vo/SearchRankItemVo.interface';
import {SearchPopularKeywordRank} from '../generated/types';

export function createSearchPopularKeywordRank({
  keyword,
  rank,
}: SearchRankItemVo): SearchPopularKeywordRank {
  return {
    id: uuidv4(),
    keyword,
    rank,
    url: `/search/result?${stringify({keyword})}`,
  };
}
